import { render } from "./intro.vue?vue&type=template&id=6c0c3f4c&ts=true"
import script from "./intro.vue?vue&type=script&lang=ts&config=true"
export * from "./intro.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__